<template>
  <div>
    <PageTitle :route="$route">
      <template slot="action-button">
        <ActionButton
          icon="fa-plus"
          v-on:click="onClickButton"
        />
      </template>
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <BankAccountList />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
  import PageTitle from '@/components/layout/PageTitle'
  import PageRowWrapper from '@/components/layout/PageRowWrapper'
  import BankAccountList from '@/components/settings/test-registers/bankAccount/BankAccountList'
  import ActionButton from '@/components/button/ActionButton'

  export default {
    name: 'BankAccount',
    components: {
      PageTitle,
      ActionButton,
      PageRowWrapper,
      BankAccountList
    },
    methods: {
    onClickButton (e) {
      this.$router.push({ name: 'addbankaccount' })
    }
  }
  }
</script>
